import { Booking } from './pages/Booking';
import { WeekBooking } from './pages/WeekBooking';
import { useWindowSize } from '../../hooks/useWindowSize';

interface Props {

}

export const BookingPage: Props = ({}) => {
    const [width, height] = useWindowSize();
    
    return (
        <div>
            { width > 1399 && width !== 0 && <WeekBooking /> }
            { width <= 1399 && width !== 0 && <Booking /> }
        </div>
    );
}
